function registrationConfirm() {
	var errorModal = $("#validationError");
	var formModal = $(".prompt-password");
	var parameters = getUrlParameters();
	var form = $("#registration-confirm-form");
	if (form.length < 1) {
		return;
	}

	$.ajax({
		url: apiPath + "validateAccount?token=" + parameters.token,
		type: "GET",
		success: function (data) {
			if (data.message == "success") {
				formModal.removeClass("hidden");
			} else {
				errorModal.removeClass("hidden");
			}
		},
		error: function () {
			errorModal.removeClass("hidden");
		}
	});

	$("input[name=token]").val(parameters.token);

	form.on("submit", function (e) {
		e.preventDefault();
		$("#submit-button").prop("disabled", true);
		var formData = form.serialize();
		$.ajax({
			url: apiPath + "registrationConfirm",
			type: "POST",
			data: formData,
			success: function (data) {
				if (data.message == "success") {
					$("#message-success").removeClass("hidden");
				} else {
					$("#message-error").html(data.responseJSON.message);
					$("#message-error").removeClass("hidden");
				}
			},
			error: function (data) {
				$("#message-error").html(data.responseJSON.message);
				$("#message-error").removeClass("hidden");
			}
		});
	});
}
